// extracted by mini-css-extract-plugin
module.exports = {"content":"AppErrorFullScreen_content__Lfqv6 typography_p3__HanLq"};